import * as React from 'react';
import { connect } from 'react-redux';
import { ApplicationState } from '../../../store';
import { SftpImportConfigurationWorkflow } from '../../../store/Models/Api/SftpImportModels';
import { ToxnotComponent, ToxnotComponentProperties } from '../../core/BaseApplicationComponents/ToxnotComponent';
import CheckBox from '../../core/CheckBox';
import TextInput from '../../core/TextInput';

interface FileStructureSectionLocalProps {
    configData: SftpImportConfigurationWorkflow;
    onConfigChange: (data: Partial<SftpImportConfigurationWorkflow>) => void;
    readOnly?: boolean;
}

type FileStructureSectionProps = FileStructureSectionLocalProps & ToxnotComponentProperties;

class FileStructureSectionComponent extends ToxnotComponent<FileStructureSectionProps> {
    render() {
        const { configData, onConfigChange, readOnly = false } = this.props;

        return (
            <div className="start-subcontent-content-container">
                <div className="form-inline margin-bottom" style={{ display: 'flex', alignItems: 'center' }}>
                    <CheckBox
                        checked={configData.hasHeader}
                        onValueChange={checked => !readOnly && onConfigChange({ 
                            hasHeader: checked,
                            headerEndRow: checked ? 1 : undefined
                        })}
                        checkboxLabelText={this.localizeString("My file has header rows ending at row")}
                        isDisabled={readOnly}
                    />
                    <div style={{width: "50px", marginLeft: "5px"}}>
                        <TextInput
                            value={configData.headerEndRow?.toString() || ""}
                            onValueChange={value => !readOnly && onConfigChange({ headerEndRow: value ? parseInt(value) : undefined })}
                            disabled={!configData.hasHeader || readOnly}
                            additionalClass="form-control"
                            isNumeric={true}
                        />
                    </div>
                </div>
                <div className="form-inline margin-bottom" style={{ display: 'flex', alignItems: 'center' }}>
                    <CheckBox
                        checked={configData.hasFooter}
                        onValueChange={checked => !readOnly && onConfigChange({ 
                            hasFooter: checked,
                            footerStartRow: checked ? 1 : undefined
                        })}
                        checkboxLabelText={this.localizeString("My file has footer rows starting at row")}
                        isDisabled={readOnly}
                    />
                    <div style={{width: "50px", marginLeft: "5px"}}>
                        <TextInput
                            value={configData.footerStartRow?.toString() || ""}
                            onValueChange={value => !readOnly && onConfigChange({ footerStartRow: value ? parseInt(value) : undefined })}
                            disabled={!configData.hasFooter || readOnly}
                            additionalClass="form-control"
                            isNumeric={true}
                        />
                    </div>
                </div>
                
                {/* Validation Messages - only show in non-readonly mode */}
                {!readOnly && (
                    <>
                        {configData.hasHeader && (configData.headerEndRow === undefined || configData.headerEndRow <= 0) && (
                            <div className="alert alert-danger" style={{marginBottom: "10px"}}>
                                {this.localizeString("Header end row must be 1 or greater when headers are enabled.")}
                            </div>
                        )}
                        {configData.hasFooter && (configData.footerStartRow === undefined || configData.footerStartRow <= 0) && (
                            <div className="alert alert-danger" style={{marginBottom: "10px"}}>
                                {this.localizeString("Footer start row must be greater than 0 when footers are enabled.")}
                            </div>
                        )}
                    </>
                )}
                
                <div className="form-group">
                    <label>{this.localizeString("Excel Tab to Import (leave blank to use the first tab in the file)")}</label>
                    <div style={{ width: "35%" }}>
                        <TextInput
                            value={configData.sheetName}
                            onValueChange={value => !readOnly && onConfigChange({ sheetName: value })}
                            disabled={readOnly}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export const FileStructureSection = connect(
    (state: ApplicationState) => ({ appServices: state.appServices! })
)(FileStructureSectionComponent);
